import React from 'react';
import '../pages/Pages.css';
import AdSense from '../AdSense';

const AboutPage = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">
          <span className="title-icon">ℹ️</span>
          About Us
        </h1>
        <p className="page-subtitle">Empowering Kenyans with Financial Knowledge</p>
      </div>

      <div className="page-content">
        {/* Top Banner Ad - Only shows if valid ad slot is configured */}
        {process.env.REACT_APP_ADSENSE_SLOT_TOP && (
          <AdSense 
            adSlot={process.env.REACT_APP_ADSENSE_SLOT_TOP}
            adFormat="auto"
            fullWidthResponsive={true}
            className="adsense-banner"
          />
        )}
        
        <div className="content-section">
          <h2>Our Mission</h2>
          <p>
            Kenyan Financial Hub is dedicated to providing accessible, accurate, and easy-to-use 
            financial calculation tools for all Kenyans. We believe that financial literacy is the 
            foundation of financial freedom, and our goal is to make complex financial calculations 
            simple and understandable.
          </p>
        </div>

        <div className="content-section">
          <h2>What We Offer</h2>
          <div className="features-list">
            <div className="feature-item">
              <span className="feature-bullet">✓</span>
              <div>
                <h3>Accurate Calculations</h3>
                <p>All our calculators are based on current Kenyan tax rates and financial regulations, ensuring you get accurate results every time.</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-bullet">✓</span>
              <div>
                <h3>Easy to Use</h3>
                <p>Our intuitive interface makes financial planning accessible to everyone, regardless of their financial background.</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-bullet">✓</span>
              <div>
                <h3>Free & Accessible</h3>
                <p>All our tools are completely free to use, with no hidden fees or subscriptions required.</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-bullet">✓</span>
              <div>
                <h3>Mobile Friendly</h3>
                <p>Access our calculators from any device - desktop, tablet, or mobile phone - for financial planning on the go.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="content-section">
          <h2>Our Calculators</h2>
          <div className="calculator-info">
            <div className="info-card">
              <h3>💰 Salary & Tax Calculator</h3>
              <p>
                Calculate your net salary after deductions including PAYE (Pay As You Earn), 
                NHIF (National Hospital Insurance Fund), and NSSF (National Social Security Fund). 
                Get a detailed breakdown of your take-home pay.
              </p>
            </div>
            <div className="info-card">
              <h3>📈 Treasury Bills & Bonds Calculator</h3>
              <p>
                Plan your investments in Kenyan government securities. Calculate returns on 
                Treasury Bills, Treasury Bonds, and Infrastructure Bonds with accurate interest 
                rate calculations.
              </p>
            </div>
            <div className="info-card">
              <h3>💎 Compound Interest Calculator</h3>
              <p>
                See how your savings and investments grow over time with compound interest. 
                Perfect for planning long-term financial goals and retirement savings.
              </p>
            </div>
          </div>
        </div>

        <div className="content-section">
          <h2>Why Choose Us?</h2>
          <p>
            We understand that financial planning can be overwhelming. That's why we've created 
            tools that simplify complex calculations and help you make informed decisions about 
            your money. Our calculators are regularly updated to reflect the latest tax rates and 
            financial regulations in Kenya.
          </p>
          <p>
            Whether you're an employee calculating your monthly take-home pay, an investor planning 
            your portfolio, or someone saving for the future, Kenyan Financial Hub is here to help 
            you achieve your financial goals.
          </p>
        </div>
        
        {/* Bottom Banner Ad - Only shows if valid ad slot is configured */}
        {process.env.REACT_APP_ADSENSE_SLOT_BOTTOM && (
          <AdSense 
            adSlot={process.env.REACT_APP_ADSENSE_SLOT_BOTTOM}
            adFormat="auto"
            fullWidthResponsive={true}
            className="adsense-banner"
          />
        )}
      </div>
    </div>
  );
};

export default AboutPage;
